import Moveable from 'react-moveable';
import { useDispatch, useSelector } from 'react-redux';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { Slider } from '@mui/material';

import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

import { useWebGL } from '../videoEdit.provider';
import { SetupTextEdit } from './Calculators/MoveableDiv';
import { getContentWidthHeight } from './Setups/SetupClass';
import { WebGLMovementEnd, WebGLStetchEnd } from './Calculators/projectjsonHelper';
import { isElementDraging_Store } from '../../../store/actions/editAction';
import { ProjectJSON_Store, StretchScreenFlag_store } from '../../../store/actions/projectdata';
import { SelectedItemID_Store, switchVideo_Store } from '../../../store/actions/webgldata';
import { SaveVideoPlaying_Store, TimeCount_Store } from '../../../store/actions/videoPlayAction';
import { GetQuerySelector } from '../../../assets/script/commonFunction';
import { DrawScene, initShaderProgram, UpdateVideoTextures, InitBuffers, UpdateServerBuffers, setGLBackground } from './Setups/SetupClass';
import { DragResizeCalculator, RotationCalculator } from './Calculators/PositionCalculators';
import { getSelectedType, getMoveableIDWithArr, getGroupoptions, convertStringtoWStringUTF16, changeZeroSecond } from '../commonFunction';
import { copyObject } from '../commonFunction';
import { getGLContext, getTextWidth,GetVideoCover } from './commonFunc';

import createTransition from 'gl-transition';
import createTexture from "gl-texture2d";
import {transitionGLSLData} from './GLSLtransitiongs/transitions.data'


let tempProjectJSON = null;
const MOVEABLE_CENTER_SNAP_THRESHOLD_PX = 10;

export const WebGLStarter = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [webGLContext, setWebGLContext] = useWebGL();
  const [mainCanvas, setMainCanvas] = useState(null);
  const [canvasGL, setCanvasGL] = useState(null);
  const dragFrameRef = useRef(null);
  const pendingDragRef = useRef(null);
  const dragSessionRef = useRef(null);
  const dragFeedbackVisibleRef = useRef(false);

  const Time_Count = useSelector((store) => store.videodata.Time_Count);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const webglDataing = useSelector(store => store.webgldata);
  const imageElements = useSelector(store => store.webgldata.imageElements);
  const moveableDivArray = useSelector(store => store.webgldata.moveableDivArray);
  const activeVideoUUID = useSelector(store => store.projectdata.activeVideoUUID);
  const activeImageUUID = useSelector(store => store.projectdata.activeImageUUID);
  const activeTextUUID = useSelector(store => store.projectdata.activeTextUUID);
  const selectedItemID = useSelector(store => store.webgldata.selectedItemID);
  const switchVideo = useSelector(store => store.webgldata.switchVideo);
  const fullScreenFlag = useSelector((store) => store.projectdata.fullScreenFlag);
  const StretchScreenFlag = useSelector((store) => store.projectdata.stretchScreenFlag);
  const VideoPlaying = useSelector((store) => store.videodata.videoPlaying)

  
  const [time, setTime] = useState(+new Date());
  // useEffect(() => {
  //   ref.current.style.display = VideoPlaying ? 'none' : '';
  // }, [VideoPlaying])

  const [groupData, setGroupData] = useState({});
  useEffect(() => {
    let groupOptions = getGroupoptions(ProjectJSON);
    tempProjectJSON = JSON.parse(JSON.stringify(ProjectJSON))
    removeNotExistsMoveable(true);
    setGroupData(groupOptions);
  }, [ProjectJSON])

  const [transitionCanvas, setTransitionCanvas] = useState();
  const [transitionCanvasGL, setTransitionCanvasGL] = useState();
  const [transitionFromID, setTransitionFromID] = useState();
  const [transitionToID, setTransitionToID] = useState()
  const [glTransitionData, setGLTransitionData] = useState();
  const [transitionFrom, setTransitionFrom] = useState();
  const [transitionTo, setTransitionTo] = useState();
  const [isTransition, setIsTransition] = useState(false);
  const [transitionTime, setTransitionTime] = useState(0);
  const [transitionDuration, setTransitionDuration] = useState();

  const clearTransition = () => {
    if (transitionCanvas) transitionCanvas.remove();
    setTransitionCanvas(null);
    setTransitionCanvasGL(null);
    setGLTransitionData(null);
    setIsTransition(false);
    setTransitionFromID(null);
    setTransitionToID(null);
  }

  useEffect(() => {
    if(switchVideo.isSwitching && !isTransition){
      let type = getSelectedType(switchVideo.videoID, ProjectJSON);
      let transitionItem = type && ProjectJSON[type] ? ProjectJSON[type][switchVideo.videoID] : null;
      let transitionConfig = transitionItem?.transition?.end;
      let transitionName = transitionConfig?.preset;
      if(transitionName && transitionName !== '-'){
        let fromObjID = switchVideo.videoID;
        let toObjID = transitionConfig?.associated_texture;
        const glslData = transitionGLSLData.find(glData => glData.type == transitionName.replaceAll('-', ''));
        const fromElement = videoElements[fromObjID];
        const toElement = videoElements[toObjID];

        if (!mainCanvas || !canvasGL || !webGLContext.webGLRef || !glslData || !fromElement || !toElement || !toObjID || toObjID === '-') {
          dispatch(switchVideo_Store({
            isSwitching: false,
            videoID: ''
          }));
          return;
        }
        
        let transitionCan = document.createElement('canvas');
        transitionCan.width = mainCanvas.width;
        transitionCan.height = mainCanvas.height;
        transitionCan.style.position = "absolute";
        transitionCan.style.top = "0";
        transitionCan.style.left = "0";
        transitionCan.style.width = `${webGLContext.webGLRef.offsetWidth}px`;
        transitionCan.style.height = `${webGLContext.webGLRef.offsetHeight}px`;
        transitionCan.style.pointerEvents = "none";
        transitionCan.style.zIndex = "3";
        mainCanvas.after(transitionCan);
        setTransitionCanvas(transitionCan);
        let transitionWebGL = getGLContext(transitionCan);
        if (!transitionWebGL) {
          transitionCan.remove();
          dispatch(switchVideo_Store({
            isSwitching: false,
            videoID: ''
          }));
          return;
        }
        transitionWebGL.pixelStorei(transitionWebGL.UNPACK_FLIP_Y_WEBGL, true);
        const buffer = transitionWebGL.createBuffer();
        transitionWebGL.bindBuffer(transitionWebGL.ARRAY_BUFFER, buffer);
        transitionWebGL.bufferData(
          transitionWebGL.ARRAY_BUFFER,
          new Float32Array([-1, -1, -1, 4, 4, -1]), // see a-big-triangle
          transitionWebGL.STATIC_DRAW
        );
        
        setTransitionToID(toObjID)
        setTransitionFromID(fromObjID)
        let glTransitionTmp;
        try {
          glTransitionTmp = createTransition(transitionWebGL, glslData);
        } catch (error) {
          console.error('Transition setup failed:', error);
          transitionCan.remove();
          dispatch(switchVideo_Store({
            isSwitching: false,
            videoID: ''
          }));
          return;
        }
        setTransitionCanvasGL(transitionWebGL);
        setGLTransitionData(glTransitionTmp);
        setIsTransition(true);
        setTransitionTime(+new Date());
        setTransitionDuration(Math.max(100, Number(transitionConfig?.duration) || 500));
      }else{
        setIsTransition(false);
        if (switchVideo.isSwitching) {
          dispatch(switchVideo_Store({
            isSwitching: false,
            videoID: ''
          }));
        }
      }
    }
  }, [switchVideo, mainCanvas, canvasGL, webGLContext.webGLRef, videoElements, ProjectJSON])

  useEffect(() => {
    if ((!switchVideo.isSwitching || !VideoPlaying) && isTransition) {
      clearTransition();
    }
  }, [switchVideo, VideoPlaying])

  useEffect(() => {
    if (!webGLContext.webGLRef) return;
    const canvasEl = webGLContext.webGLRef;
    const canvasGl = getGLContext(canvasEl);
    const shaderProgram = initShaderProgram(canvasGl);
    
    const programData = {
      program: shaderProgram,
      attribLocations: {
        vertexPosition: canvasGl.getAttribLocation(shaderProgram, 'aVertexPosition'),
        textureCoord: canvasGl.getAttribLocation(shaderProgram, 'aTextureCoord'),
      },
      uniformLocations: {
        projectionMatrix: canvasGl.getUniformLocation(shaderProgram, 'uProjectionMatrix'),
        modelViewMatrix: canvasGl.getUniformLocation(shaderProgram, 'uModelViewMatrix'),
        //filterPreset_m: canvasGl.getUniformLocation(shaderProgram, 'aFilterPreset_m'),
        //filterPreset_v: canvasGl.getUniformLocation(shaderProgram, 'aFilterPreset_v'),
        isGreen: canvasGl.getUniformLocation(shaderProgram, 'isGreen'),
        transparency: canvasGl.getUniformLocation(shaderProgram, 'transparency'),
        editValue: canvasGl.getUniformLocation(shaderProgram, 'edit_values'),
        blackWhiteFilter: canvasGl.getUniformLocation(shaderProgram, 'blackwhite'),
        uSampler: canvasGl.getUniformLocation(shaderProgram, 'uSampler'),
      },
    }

    setWebGLContext({ ...webGLContext, programInfo: programData });
    setMainCanvas(canvasEl);
    setCanvasGL(canvasGl);
     
    
  }, [webGLContext.webGLRef])

  const [keepRatio, setKeepRatio] = useState(true);
  const [moveableRef, setMoveableRef] = useState(null);
  useEffect(() => {
    getMoveableTarget();

    let tempKeepRatio = true;
    if (!!selectedItemID) {
      let type = getSelectedType(selectedItemID, ProjectJSON);
      if (type === 'text') tempKeepRatio = false;
    }

    if (tempKeepRatio !== keepRatio) {
      setKeepRatio(tempKeepRatio);
    }
  }, [selectedItemID, fullScreenFlag])

  useEffect(() => {
    if (!selectedItemID) return;
    let types = ['text', 'videos', 'images'];
    let type = getSelectedType(selectedItemID, ProjectJSON);
    let checkType = types.find((t) => t === type);
    if (!checkType) return;

    let tempJSON = JSON.parse(JSON.stringify(ProjectJSON));
    let selectedItem = tempJSON[type][selectedItemID];
    if (!selectedItem) return;

    let indicatorT = Time_Count.getTime();
    let endTime = selectedItem?.timeline_end;
    let startTime = selectedItem?.timeline_start;
    if (endTime < 0 || !endTime && endTime !== 0) return;
    if (indicatorT < 0 || !indicatorT && indicatorT !== 0) return;
    if (startTime < 0 || !startTime && startTime !== 0) return;
    if (startTime <= indicatorT && indicatorT <= endTime) return;

    let nextTime = 0;
    if (indicatorT >= endTime) nextTime = endTime - 1;
    else nextTime = startTime;

    let newTime = new Date(nextTime);
    if (nextTime !== indicatorT) dispatch(TimeCount_Store(newTime))
  }, [selectedItemID])

  const getMoveableTarget = () => {
    let selectedItemTmp = selectedItemID;
    if(Array.isArray(selectedItemID)){
      selectedItemTmp = getMoveableIDWithArr(selectedItemID, ProjectJSON);
    }
    const targetRef = GetQuerySelector(`.thDiv${selectedItemTmp}`);
    if (!selectedItemID || !targetRef || fullScreenFlag) {
      setMoveableRef(null);
    } else {
      const targetRef = GetQuerySelector(`.thDiv${selectedItemTmp}`);
      setMoveableRef(targetRef);
    }
  }

  
  
  useEffect(() => {
    
    let handler = setTimeout(async () => {
      let is_canvas_changed = true;
      await setTime(+new Date());

      if (!mainCanvas || !webGLContext.activeTextures.size) return;
      //const bgImg = document.getElementById('greenBg');
      //setGLBackground(canvasGL, webGLContext, bgImg);
      if(switchVideo.isSwitching && isTransition){
        if(VideoPlaying && transitionCanvas && transitionCanvasGL && glTransitionData){
          const fromElement = videoElements[transitionFromID];
          const toElement = videoElements[transitionToID];
          if (!fromElement || !toElement) {
            dispatch(switchVideo_Store({
              isSwitching: false,
              videoID: ''
            }));
          } else {
            const fromTransitionImg = createTexture(transitionCanvasGL, fromElement);
            const toTransitionImg = createTexture(transitionCanvasGL, toElement);
            const progress = Math.min(1, Math.max(0, ((time - transitionTime) / transitionDuration)));
            const drawWidth = webGLContext.webGLRef.offsetWidth;
            const drawHeight = webGLContext.webGLRef.offsetHeight;

            glTransitionData.draw(progress, fromTransitionImg, toTransitionImg, drawWidth, drawHeight, { resizeMode: "stretch" });
            fromTransitionImg.dispose?.();
            toTransitionImg.dispose?.();

            if(progress >= 0.99){
              clearTransition();
              setTransitionTime(+new Date());
              dispatch(switchVideo_Store({
                isSwitching: false,
                videoID: ''
              }));
            }
          }
        }
      }
      if(activeVideoUUID.length > 0){
       activeVideoUUID.forEach(function (key) {
          if (!videoElements[key]) return;
          const currentTexture = webGLContext.activeTextures.get(key);
          if(videoElements[key].readyState == 4) {
            UpdateVideoTextures(canvasGL, currentTexture, videoElements[key]);
          } else {
            is_canvas_changed = false;
          }
        })  
      }
      activeImageUUID.forEach(function (key) {
        if (!imageElements[key]) return;
        const currentTexture = webGLContext.activeTextures.get(key);
        UpdateVideoTextures(canvasGL, currentTexture, imageElements[key]);
      })
      if (is_canvas_changed) {
        DrawScene(canvasGL, webGLContext, ProjectJSON, groupData, Time_Count);
        setCanvasGL(canvasGL);
      }
    }, 50);
    return () => handler && clearTimeout(handler);
  }, [time, switchVideo]);

  useEffect(() => {
    if (!!mainCanvas) {
      AddEventListerMoveableDivs()
    }
  }, [moveableDivArray, mainCanvas, fullScreenFlag])


  const serverTextRef = useRef();
  serverTextRef.current = [''];
  const AddEventListerMoveableDivs = async () => {
    await removeNotExistsMoveable(fullScreenFlag);

    if (!fullScreenFlag) {
      const textOb = ProjectJSON.text;
      const moveableParentEL = ref.current;
      const MoveableKeys = Object.keys(moveableDivArray);
      MoveableKeys.forEach(function (moveableKey) {
        moveableDivArray[moveableKey].addEventListener('click', () => {
          dispatch(SelectedItemID_Store(moveableKey));
        }, false)

        const MoveableRefs = Array.from(moveableParentEL.children);
        const MoveableItem = MoveableRefs.find((inputRef) => { return inputRef.getAttribute('id') === moveableKey; });
        if (!MoveableItem) moveableParentEL.appendChild(moveableDivArray[moveableKey]);
        // append the moveable divs into the parent div if not found

        const checkTextOb = activeTextUUID.find((textkey) => textkey === moveableKey);
        if (!checkTextOb) return;

        // const textItemOb = textOb[checkTextOb];
        // const moveableItem = moveableDivArray[moveableKey];
        // const SetTextParam = [textItemOb, moveableItem, checkTextOb, serverTextRef, webGLContext, ProjectJSON, mainCanvas];

        // SetupTextEdit(...SetTextParam, (changedText, textItemKey) => {
        //   let newJSONData = Object.assign({}, tempProjectJSON);
        //   const textitem = newJSONData.text[textItemKey];
        //   if (!textitem || textitem.context === changedText) return;

        //   let [maxWidth, maxHeight, acceptRatio] = getContentWidthHeight(changedText, ProjectJSON, textitem, mainCanvas);
        //   newJSONData.text[textItemKey].context = changedText;
        //   newJSONData.text[textItemKey].contextutf16 = convertStringtoWStringUTF16(changedText);
        //   textitem.dimension.h = maxHeight / acceptRatio;
        //   textitem.dimension.w = maxWidth / acceptRatio;
        //   dispatch(ProjectJSON_Store(newJSONData));
        //   changeZeroSecond(textitem, dispatch)
        // })
      })

      getMoveableTarget()
    }
  }

  const removeNotExistsMoveable = (state) => {
    const moveableParentEL = ref.current;
    const activeKeys = activeVideoUUID.concat(activeTextUUID);
    const moveableInputs = Array.from(moveableParentEL.children);
    moveableInputs.forEach((inputRef) => {
      const id = inputRef.getAttribute('id');
      if (!id) return;
      const checkActiveKey = activeKeys.find((activeKey) => activeKey === id);
      if (!checkActiveKey || state) inputRef.remove();
    })

    return;
  }

  // Moveable Event Function START
  const applyMoveableDrag = (props) => {
    const { target, width, height } = props;
    if (!target || !mainCanvas) return;

    let session = dragSessionRef.current;
    if (!session || session.target !== target) {
      const type = getSelectedType(target.id, ProjectJSON);
      if (!type) return;
      session = {
        target,
        centerX: mainCanvas.clientWidth / 2,
        centerY: mainCanvas.clientHeight / 2,
      };
      dragSessionRef.current = session;
    }

    let left = props.left;
    let top = props.top;
    const ActiveMatrices = webGLContext.activeModelViewMatrices
    const calulatedTop = top + (height / 2);
    const calculatedLeft = (left + (width / 2));

    if (Math.abs(calulatedTop - session.centerY) < MOVEABLE_CENTER_SNAP_THRESHOLD_PX) {
      top = session.centerY - (height / 2);
    }
    if (Math.abs(calculatedLeft - session.centerX) < MOVEABLE_CENTER_SNAP_THRESHOLD_PX) {
      left = session.centerX - (width / 2);
    }

    target.style.top = `${top}px`;
    target.style.left = `${left}px`;

    let Matrix = ActiveMatrices.get(target.id);
    if (!Matrix) return;
    Matrix = DragResizeCalculator({ ...props, left, top }, mainCanvas, Matrix);
    ActiveMatrices.set(target.id, Matrix);
    if (canvasGL) DrawScene(canvasGL, webGLContext, ProjectJSON, groupData, Time_Count);
  }

  const flushMoveableDrag = () => {
    if (dragFrameRef.current) cancelAnimationFrame(dragFrameRef.current);
    dragFrameRef.current = null;
    const pendingDrag = pendingDragRef.current;
    pendingDragRef.current = null;
    if (pendingDrag) applyMoveableDrag(pendingDrag);
  }

  const MoveableDragFunc = (props) => {
    pendingDragRef.current = props;
    if (!dragFeedbackVisibleRef.current) {
      dragFeedbackVisibleRef.current = true;
      props.target.style.willChange = 'left, top';
      dispatch(isElementDraging_Store(true));
    }
    if (dragFrameRef.current) return;
    dragFrameRef.current = requestAnimationFrame(() => {
      dragFrameRef.current = null;
      const pendingDrag = pendingDragRef.current;
      pendingDragRef.current = null;
      if (pendingDrag) applyMoveableDrag(pendingDrag);
    });
  }

  const MoveableDragEnd = async (props) => {
    flushMoveableDrag();
    try {
      await JSONdataSaveFunc(props);
    } finally {
      if (props.target) props.target.style.willChange = '';
      dragSessionRef.current = null;
      if (dragFeedbackVisibleRef.current) {
        dragFeedbackVisibleRef.current = false;
        dispatch(isElementDraging_Store(false));
      }
    }
  }

  const MoveableResizeFuc = (props) => {
    let tempJSON = {...ProjectJSON}
    const tmpProps = props;
    let { target, width, height, drag, delta } = tmpProps;
    const ActiveMatrices = webGLContext.activeModelViewMatrices
    const type = getSelectedType(target.id, tempJSON)
    if (!type) return

    let activeUUID = target?.id || selectedItemID
    if (type === 'text') {
      let textInfo = tempJSON[type][activeUUID]

      let canvasW = webGLContext.webGLRef.offsetWidth
      let acceptRatio = canvasW / tempJSON.width
      let response = getNextFontSize(textInfo, height / acceptRatio)
      let [nextWidth, nextSize, rowCount] = response
      nextSize = parseFloat(nextSize.toFixed(1))

      let nextHeight = (nextSize * 3 * 1.3) * rowCount
      height = nextHeight * acceptRatio
      width = nextWidth * acceptRatio

      textInfo.dimension.w = nextWidth
      textInfo.dimension.h = nextHeight
      textInfo.properties.font_size = nextSize
    }

    target.style.width = `${width}px`
    target.style.height = `${height}px`
    target.style.left  = `${drag.left}px`;
    target.style.top  = `${drag.top}px`;
    // delta[0] && (target.style.width = `${width}px`)
    // delta[1] && (target.style.height = `${height}px`)

    tmpProps['top'] = drag.top
    tmpProps['left'] = drag.left
    let Matrix = ActiveMatrices.get(target.id)
    const resizeData = [tmpProps, mainCanvas, Matrix, type, webGLContext, activeUUID, canvasGL, tempJSON];
    Matrix = DragResizeCalculator(...resizeData);
    ActiveMatrices.set(target.id, Matrix);
  }

  const MoveableRotate = (props) => {
    const { target, transform } = props
    const ActiveMatrices = webGLContext.activeModelViewMatrices

    const elementID = target.id
    let type = getSelectedType(elementID, ProjectJSON)
    if (!type || type === '') return

    if (type === 'text') return
    target.style.transform = transform
    const CSSText = target.style.cssText
    let newMatrix = ActiveMatrices.get(elementID)

    newMatrix = RotationCalculator(CSSText, newMatrix)
    ActiveMatrices.set(elementID, newMatrix)
  }

  const JSONdataSaveFunc = async ({ target, isDrag }, flag) => {
    if (!isDrag) return
    let activeUUID = target?.id || selectedItemID
    let type = getSelectedType(activeUUID, ProjectJSON);
    if (!type) return

    let tempJSON = copyObject(ProjectJSON)
    let itemInfo = tempJSON[type][activeUUID]
    const props = [target, mainCanvas, tempJSON, itemInfo]
    const positionData = await WebGLMovementEnd(...props)

    if (type === 'text' && flag === 'resize') {
      let height = positionData.dimension.h
      let response = getNextFontSize(itemInfo, height)
      let [nextWidth, nextSize, rowCount] = response
      nextSize = parseFloat(nextSize.toFixed(1))

      let nextHeight = (nextSize * 3 * 1.3) * rowCount
      itemInfo.dimension.h = nextHeight
      itemInfo.dimension.w = nextWidth
      // itemInfo.coordinate = positionData.coordinate
      itemInfo.properties.font_size = nextSize
    } else itemInfo.dimension = positionData.dimension

    if (type === 'text' && flag === 'rotate') return
    itemInfo.coordinate = positionData.coordinate
    itemInfo.rotation = positionData.rotation
    dispatch(ProjectJSON_Store(tempJSON));
    changeZeroSecond(itemInfo, dispatch)
  }
  // Moveable Event Function END

  useEffect(() => {
    if(StretchScreenFlag){
      StretchScreen();
    }
  }, [StretchScreenFlag])
  const moveableDom = useRef();
  useEffect(() => () => {
    if (dragFrameRef.current) cancelAnimationFrame(dragFrameRef.current);
    if (dragSessionRef.current?.target) dragSessionRef.current.target.style.willChange = '';
    if (dragFeedbackVisibleRef.current) dispatch(isElementDraging_Store(false));
    dragFrameRef.current = null;
    pendingDragRef.current = null;
    dragSessionRef.current = null;
    dragFeedbackVisibleRef.current = false;
  }, [dispatch]);

  const StretchScreen = async () => {
    let activeUUID = selectedItemID
    let type = getSelectedType(activeUUID, ProjectJSON);
    
    if(type == 'videos' || type == 'images'){
      let currentTarget = moveableDom.current.props.target;
      if(currentTarget.id == activeUUID){
        currentTarget.style.width = `${webGLContext.webGLRef.offsetWidth}px`;
        currentTarget.style.height = `${webGLContext.webGLRef.offsetHeight}px`;
       // currentTarget.offsetWidth = webGLContext.webGLRef.offsetWidth;
        const ActiveMatrices = webGLContext.activeModelViewMatrices
        let Matrix = ActiveMatrices.get(selectedItemID)
        let tempJSON = copyObject(ProjectJSON)
        const resizeData = [
            {left: 0, top: 0, 
              width: webGLContext.webGLRef.offsetWidth, 
              height: webGLContext.webGLRef.offsetHeight,
               zIndex: currentTarget.style.zIndex}, 
               mainCanvas, Matrix,
               type, webGLContext, activeUUID, canvasGL, tempJSON
              ]
        Matrix = DragResizeCalculator(...resizeData)
        ActiveMatrices.set(selectedItemID, Matrix)
        const elementRatio = type == 'videos'? videoElements[activeUUID].videoHeight / videoElements[activeUUID].videoWidth : imageElements[activeUUID].height / imageElements[activeUUID].width;
        
        let itemInfo = tempJSON[type][activeUUID]
        const webGLprops = [
          {left: 0, top: 0, 
            width: webGLContext.webGLRef.offsetWidth, 
            height: webGLContext.webGLRef.offsetHeight,
            transform: webGLContext.webGLRef.style.transform 
          },
           mainCanvas, tempJSON, itemInfo,
           elementRatio
          ]
        const positionData = await WebGLStetchEnd(...webGLprops)
    
        itemInfo.dimension = positionData.dimension
        itemInfo.coordinate = positionData.coordinate
        itemInfo.rotation = positionData.rotation;
        itemInfo.ratioWH = positionData.ratioWH;
        dispatch(ProjectJSON_Store(tempJSON));
        changeZeroSecond(itemInfo, dispatch)
      }
    }

    setTimeout(() => { dispatch(StretchScreenFlag_store(false)) }, 100);
  }

  let fullScreenCtrlHeight = ref?.current?.offsetHeight / 6
  if (!fullScreenCtrlHeight || fullScreenCtrlHeight > 100) {
    fullScreenCtrlHeight = 100
  }

  let [maxCount, setMaxCount] = useState(0)
  let [duration, setDuration] = useState('')

  useEffect(() => {
    if (ProjectJSON.duration) {
      let tempTime = new Date(ProjectJSON.duration)
      let tempDuration = tempTime.MMSSM()

      if (duration !== tempDuration) {
        setDuration(tempDuration)
      }

      if (maxCount !== ProjectJSON.duration) {
        setMaxCount(ProjectJSON.duration)
      }
    } else {
      setDuration("")
    }
    
  }, [ProjectJSON])

  const VideoPlayFunc = (status) => {
    dispatch(SaveVideoPlaying_Store(status));
  }

  return (
    <div className='moveable-wrapper relative' ref={ref}>
      <Moveable className='moveable-container_'
        ref={moveableDom}
        target={moveableRef}
        container={null}
        origin={true}
        edge={false} // Resize event edges
        draggable={true} // draggable
        throttleDrag={0}
        onDragStart={(props) => { }} //{ target, clientX, clientY }
        onDrag={(props) => { MoveableDragFunc(props); }}
        onDragEnd={(props) => { MoveableDragEnd(props); }}

        keepRatio={keepRatio} // When resize or scale, keeps a ratio of the width, height.
        resizable={true} // resizable
        throttleResize={1}
        onResizeStart={(props) => { }} //{ target, clientX, clientY }
        onResize={(props) => { MoveableResizeFuc(props); }}
        onResizeEnd={(props) => { JSONdataSaveFunc(props, 'resize'); }}
        
        
        rotatable={true} // rotatable
        throttleRotate={0}
        onRotateStart={(props) => { }} //{ target, clientX, clientY }
        onRotate={(props) => { MoveableRotate(props); }}
        onRotateEnd={(props) => { JSONdataSaveFunc(props, 'rotate'); }}
      />

      {fullScreenFlag && (
        <div className='fullscreen-wrapper flex flex-col justify-center px-5 md:px-30 bg-fullScreen text-white'
          style={{ height: fullScreenCtrlHeight + 'px' }}
        >
          <div className='max-h-40 h-full flex flex-row gap-15 md:gap-30 items-center'>
            {VideoPlaying && (
              <div className='h-full cursor-pointer' onClick={() => { VideoPlayFunc(false) }}>
                <PauseIcon style={{ height: '100%', width: 'auto' }} />
              </div>
            )}

            {!VideoPlaying && (
              <div className='h-full cursor-pointer' onClick={() => { VideoPlayFunc(true) }}>
                <PlayArrowIcon style={{ height: '100%', width: 'auto' }} />
              </div>
            )}

            <div className='video-ctrl flex-1 pr-0'>
              <Slider track={false} onChange={() => { }}
                value={+ new Date(Time_Count)} min={0} max={maxCount}
              />
            </div>

            <div className='flex flex-row gap-5 items-center text-15 opacity-75'>
              {Time_Count.MMSSM()}

              {duration && (
                <span className='hidden md:flex'> / {duration}</span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
})

const getNextFontSize = (textInfo, height) => {
  let bold = textInfo.properties.bold
  let font_family = textInfo.properties.font_family
  let font_size = textInfo.properties.font_size * 3
  let options = { font: font_family, fontSize: font_size + 'px', fontWeight: bold }

  let mw = 0
  let maxText = ''
  let textRows = textInfo.context.split('?entered!*-')
  textRows.forEach((text) => {
    let size = getTextWidth(text, options)
    if (mw < size.width) maxText = text
    if (mw < size.width) mw = size.width
  })

  let len = textRows.length
  let nextSize = (height / len) / 1.3
  let options1 = { font: font_family, fontSize: nextSize + 'px', fontWeight: bold }
  let size = getTextWidth(maxText, options1)
  let nextWidth = size.width + 60

  return [nextWidth, nextSize / 3, textRows.length]
}
